import $ from 'jquery';

const DEFAULT_SETTINGS = {
	//
};

class Page {
	constructor(config) {
		this.config = config;

		this.$videoEmbedsInType = $(
			`iframe[src*='vimeo.com'], iframe[src*='youtube.com']`,
			'.typography'
		);
		this.$tablesInType = $('table', '.typography');
		this.$window = $(window);
		this.$html = $('html');
		this.$body = $('body');
	}

	get $tableWrappers() {
		return $('.table-wrapper');
	}

	updateTableAttributes() {
		this.$tableWrappers.each((index, node) => {
			let $node = $(node);

			let $inner = $node.find('.table-wrapper__inner');
			let scrollWidth = $inner.get(0).scrollWidth;
			let clientWidth = $inner.get(0).clientWidth;

			if (scrollWidth > clientWidth) {
				$node.addClass('table-wrapper--overflow').attr({ tabindex: '0', role: 'group' });
			} else {
				$node.removeClass('table-wrapper--overflow').removeAttr('tabindex role');
			}
		});
	}

	onFormstoneReady() {
		this.$body.removeClass('preload').addClass('loaded');
		this.$window.trigger('resize');
	}

	onWindowResize() {
		this.updateTableAttributes();
	}

	bindUI() {
		window.Formstone.Ready(this.onFormstoneReady.bind(this));

		window.addEventListener('resize', this.onWindowResize.bind(this));
	}

	setup() {
		this.$videoEmbedsInType.removeAttr('style').wrap('<div class="video-frame"></div>');

		this.$tablesInType.wrap(
			'<div class="table-wrapper"><div class="table-wrapper__inner"></div></div>'
		);

		this.updateTableAttributes();
	}

	init() {
		this.setup();
		this.bindUI();
	}
}

export default function factory() {
	let module = new Page(DEFAULT_SETTINGS);

	module.init();

	return module;
}
